import apiFetch from '../../apiFetch'

export default function (campaignId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/campaign/${campaignId}`, method: 'DELETE', token: token, lastAccessDate })
}
